module.exports = __webpack_public_path__ + "img/hospitalBanner.509183fa.png";